"use client";

import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import BrandsSkeleton from "@/components/SkeletonComponent/BrandsSectionSkeleton";

const BrandSliderNew = dynamic(() => import("@/sliders/BrandSliderNew"), {
  ssr: false,
  loading: () => <BrandsSkeleton />,
});

const BrandSliderr = dynamic(() => import("@/app/our-brands/BrandSliderr"), {
  ssr: false,
  loading: () => <BrandsSkeleton />,
});

export default function ResponsiveBrandSlider({ breakpoint = 768 }) {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.innerWidth < breakpoint;
  });

  useEffect(() => {
    if (typeof window === "undefined") return;

    const media = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const onChange = (event) => setIsMobile(event.matches);

    setIsMobile(media.matches);
    if (media.addEventListener) media.addEventListener("change", onChange);
    else media.addListener(onChange);

    return () => {
      if (media.removeEventListener) media.removeEventListener("change", onChange);
      else media.removeListener(onChange);
    };
  }, [breakpoint]);

  return (
    <>
      <section className="desktop-brands">{isMobile ? null : <BrandSliderr />}</section>
      <section className="mobile-brands">{isMobile ? <BrandSliderNew /> : null}</section>
    </>
  );
}

